import { useMemo } from 'react';
import type { PersonalSettingsPage } from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';
import { forgePersonalSettingsPageModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { useResource } from '@atlassian/react-resource-router';
import { useForgeItemStack } from '../../common/utils/find-item-stack/index.tsx';
import type { UseNavigationResourceReturnWithStack } from '../types.tsx';

export const usePersonalSettingsForgeApps = (
	routeName?: string,
): UseNavigationResourceReturnWithStack<PersonalSettingsPage[]> => {
	const { data, loading, error } = useResource(forgePersonalSettingsPageModuleResource);
	const stack = useForgeItemStack(data, routeName);
	return useMemo<UseNavigationResourceReturnWithStack<PersonalSettingsPage[]>>(() => {
		return {
			data,
			loading,
			error,
			stack,
		};
	}, [data, loading, error, stack]);
};
